export default Object.freeze({
  SET_LAST_UNAUTHORIZED_PATH: 'setLastUnauthorizedPath',
  CLEAR_LAST_UNAUTHORIZED_PATH: 'clearLastUnauthorizedPath',
  SIGN_IN: 'signIn',
  REFRESH_JWT_TOKEN: 'refreshJwtToken',
  SET_AUTHORITY: 'setAuthority',
  SET_BASIC_INFO: 'setBasicInfo',
  SET_BASE64_AVATAR: 'setBase64Avatar',
  SET_USERNAME: 'setUserName',
  SET_MODULE_CATEGORIES: 'setModuleCategories',
  SET_BREADCRUMBS: 'setBreadcrumbs',
  SET_MODULE_BREADCRUMBS: 'setModuleBreadcrumbs',
  ADD_EXTRA_BREADCRUMB: 'addExtraBreadcrumb',
  SIGN_OUT: 'signOut',
  SET_SEARCHABLE_INFO: 'setSearchableInfo',
  SET_MASTER_ARENAS: 'setMasterArenas',
  SET_EVENT_CATEGORIES: 'setEventCategories',

  SET_EVENT_UNDER_EDIT: 'setEventUnderEdit',
  SET_SHOW_UNDER_EDIT: 'setShowUnderEdit',

  SET_MERCHANDISE_TYPES: 'setMerchandiseTypes',
  SET_SHOW_MENU: 'setShowMenu',
  TOGGLE_MENU: 'toggleMenu',
  MARK_IS_ALL_LOADED: 'markIsAllLoaded',
  SET_THEME: 'setTheme',
});
